module.exports = __webpack_public_path__ + "img/log-out-icon-gray.963f7966.png";